const clientReviews = {
    init() {
        this.initSlider();
    },

    initSlider() {
        const $slider = $('.client-reviews__slider');

        if ($slider.length && $(window).width() < 768) {
            $slider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                infinite: true,
                speed: 300,
                adaptiveHeight: true,
                prevArrow: '<button type="button" class="slick-prev"></button>',
                nextArrow: '<button type="button" class="slick-next"></button>',
            });
        }
    }
};

export default clientReviews;
